import React from 'react';
import { motion } from 'framer-motion';
import { Container } from 'react-bootstrap';
import RepairBlock from '../../components/RepairBlock';

export default class ServicePage extends React.Component {
  render() {
    return (
      <div style={{ background: '#080808', paddingTop: '78px' }}>

        {/* ── Hero ── */}
        <section style={{
          minHeight: '38vh',
          background: 'linear-gradient(135deg, #0d0d0d 0%, #110404 100%)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          position: 'relative', overflow: 'hidden', padding: '70px 5%',
        }}>
          <div style={{
            position: 'absolute', top: '-15%', right: '-5%', width: '400px', height: '400px',
            borderRadius: '50%', pointerEvents: 'none',
            background: 'radial-gradient(circle, rgba(198,21,21,0.1) 0%, transparent 70%)',
          }} />
          <div style={{
            position: 'absolute', inset: 0, pointerEvents: 'none',
            backgroundImage: 'linear-gradient(rgba(255,255,255,0.012) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.012) 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }} />
          <motion.div
            initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}
            style={{ textAlign: 'center', position: 'relative', zIndex: 1 }}
          >
            <div style={{ fontSize: '11px', letterSpacing: '4px', color: '#c61515', fontWeight: '800', marginBottom: '16px' }}>
              PROFESSIONAL REPAIRS
            </div>
            <h1 style={{ color: 'white', fontSize: 'clamp(30px, 5vw, 54px)', fontWeight: '900', margin: '0 0 18px', lineHeight: '1.1' }}>
              Book Your{' '}
              <span style={{
                background: 'linear-gradient(135deg, #dd4d4e, #780e0f)',
                WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
              }}>
                Repair
              </span>
            </h1>
            <p style={{ color: '#777', fontSize: '15px', maxWidth: '500px', margin: '0 auto', lineHeight: '1.85' }}>
              Select your device, choose your service, and book an appointment — all in minutes.
            </p>
          </motion.div>
        </section>

        {/* ── Repair Booking Form ── */}
        <section style={{ padding: '60px 5%', background: '#080808' }}>
          <motion.div
            initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3, duration: 0.6 }}
            style={{
              background: 'rgba(255,255,255,0.025)',
              border: '1px solid rgba(198,21,21,0.18)',
              borderRadius: '20px', overflow: 'hidden',
              maxWidth: '1000px', margin: '0 auto',
            }}
          >
            <RepairBlock />
          </motion.div>
        </section>

        {/* ── Terms & Conditions ── */}
        <section style={{ padding: '20px 5% 90px', background: '#080808' }}>
          <Container style={{ maxWidth: '900px' }}>
            <motion.div
              initial={{ opacity: 0 }} whileInView={{ opacity: 1 }}
              viewport={{ once: true }} transition={{ duration: 0.6 }}
              style={{
                background: 'rgba(255,255,255,0.02)',
                border: '1px solid rgba(255,255,255,0.06)',
                borderRadius: '16px', padding: '40px',
              }}
            >
              <h2 style={{ color: '#c61515', fontSize: 'clamp(20px, 3vw, 26px)', fontWeight: '800', margin: '0 0 24px' }}>
                Terms &amp; Conditions
              </h2>

              {[
                {
                  heading: '1. All repairs (unless otherwise stated)',
                  paras: [
                    '1. We shall make reasonable efforts to repair your Device subject to the availability of any parts required and/or the terms of any relevant guarantee or warranty. We shall perform the Service using our utmost care and skill.',
                    '2. We offer both high-quality after-market and OEM (genuine) parts (where possible) for the repairs of your device.',
                    '2.1 We perform a series of tests when booking a device in for repair. If the device is not testable during this stage, Phone Clinic is not liable for any faults found therefore we shall require the passcode of your Device to test the Device before and after the Service.',
                    '2.2 Any time estimate for completion of the service is an estimate only and does not form any obligation under this Agreement.',
                    '2.3 If we are unable to complete the Service for any reason, or the Service will incur further costs payable by you beyond that initially estimated, we will notify you immediately.',
                    '2.4 In order to complete a diagnostic or repairs it may be necessary to disassemble the device. Phone Clinic take no liability for any further damage due to existing damage.',
                    '2.11 Our products and repairs are covered by the warranty terms:\n\nIPHONE SCREENS — Premium Service: Lifetime Warranty | Standard Service: 1 Year Warranty\nIPHONE BATTERY: 1 Year Warranty\nALL OTHER BRANDS: 6 Months Warranty on Screen, Batteries 12 Month Warranty\nALL SMALL PARTS: 1 Year Warranty',
                    '2.12 The Warranty is linked to a specific device as identified by its unique IMEI or serial number and to a specific Customer as identified by the records on our system.',
                  ],
                },
                {
                  heading: '4. Data Protection',
                  paras: [
                    '4.1 We ask for your name and address and any other relevant details so that we can notify you when your Device has been repaired and provide you with an efficient after-sales service.',
                  ],
                },
                {
                  heading: '5. General',
                  paras: [
                    '5.1 We shall not be liable to you for any delay in our failure of performance of our obligations arising from any reason beyond our reasonable control.',
                    '5.7 This Agreement shall be governed by the laws of England and Wales and shall be subject to the exclusive jurisdiction of the English Courts.',
                  ],
                },
                {
                  heading: 'Declaration',
                  paras: [
                    'By signing our Service Consent, you certify that you have read this agreement, that you know and understand the meaning and intent of this agreement and that you are entering this agreement knowingly and voluntarily.',
                  ],
                },
              ].map((section) => (
                <div key={section.heading} style={{ marginBottom: '28px' }}>
                  <h6 style={{ color: '#c61515', fontSize: '13px', fontWeight: '800', letterSpacing: '0.5px', margin: '0 0 12px' }}>
                    {section.heading}
                  </h6>
                  {section.paras.map((p, i) => (
                    <p key={i} style={{ color: '#666', fontSize: '13px', lineHeight: '1.8', margin: '0 0 10px', whiteSpace: 'pre-line' }}>
                      {p}
                    </p>
                  ))}
                </div>
              ))}
            </motion.div>
          </Container>
        </section>
      </div>
    );
  }
}
